import setting from '@/setting';
/**
 * 读取印章
 * @param {*} data 
 * @param {*} type 
 * @param {*} callback 
 * @param {*} finishCallback 
 */
export const readSeal = (data, type, callback, finishCallback) => {
  const ws = new WebSocket(`${setting.UKEY_URL}${type}`);
  ws.onopen = function () {
    ws.send(data);
  }
  ws.onmessage = function (e) {
    // console.log('!!!!!!', e)
    let state = false;
    let result;
    if (type === 'readseal') {
      const dataArray = e.data.split(',');
      state = dataArray[0] === 'true';
      result = dataArray[1];
    } else if (type === 'sign') {
      state = true;
      result = e.data;
    }

    if (state) {
      callback(true, result, e)
    } else {
      callback(false, '传入的type类型不支持！')
    }
    ws.close();
  }
  ws.onerror = function (e) {
    console.log('error::::', e)
    if (ws.readyState != WebSocket.OPEN) {
      callback(false, 'ukey链接失败，请检查设备是否已正确插入！')
    }
  }
  ws.onclose = function (e) {
    if (e.code != 1000) {
      if (e.reason != "") {
        callback(false, e.reason);
      }
    }
    if (finishCallback) {
      finishCallback(e);
    }
  }
}


// WEBPACK FOOTER //
// ./src/utils/ukeyUtil.js